// src/lib/useProfitPeriod.ts
// [2026-07-17] 粗利分析タブ専用の期間解決。
// profitFrom/profitTo (store) が null なら「最新確定月のみ」(= meta.dateMax の月) を default に。
// 他タブの periodFrom/periodTo からは独立 (粗利分析の期間変更が他タブへ波及しない)。
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { useFilters } from "../store";

export function useProfitPeriod(): {
  from: string;    // "YYYY-MM-01"
  to: string;      // "YYYY-MM-01"
  isLatestOnly: boolean;   // default (= 最新月のみ・override 無し) か
  minYM: string;   // meta.dateMin の "YYYY-MM"
  maxYM: string;   // meta.dateMax の "YYYY-MM"
} {
  const f = useFilters();
  // meta は App/BetaApp が同じ queryKey で取得済 = キャッシュ共有・追加リクエストなし
  const { data: meta } = useQuery({ queryKey: ["meta"], queryFn: api.meta, staleTime: Infinity });
  const latest = meta?.dateMax ? meta.dateMax.slice(0, 8) + "01" : null;
  const from = f.profitFrom ?? latest ?? f.periodFrom;
  const to   = f.profitTo   ?? latest ?? f.periodTo;
  return {
    from, to,
    isLatestOnly: f.profitFrom == null && f.profitTo == null,
    minYM: meta?.dateMin?.slice(0, 7) ?? from.slice(0, 7),
    maxYM: meta?.dateMax?.slice(0, 7) ?? to.slice(0, 7),
  };
}
